import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=0a7e5628&scoped=true&"
import script from "./VMenu.vue?vue&type=script&lang=ts&"
export * from "./VMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VMenu.vue?vue&type=style&index=0&id=0a7e5628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e5628",
  null
  
)

export default component.exports